<template>
  <div>
    <b><span>Resumo:</span></b>
    <br>
    <div>
      <div>
        <span><strong>Decisão:</strong> {{ obterDecisao() }} <br></span>
        <span v-show="obterDetalhesDecisao()"><strong>Detalhes da Decisão:</strong> {{ obterDetalhesDecisao() }} <br></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onboarding: Object,
    comparativoDados: Array,
    situacaoBmpOrigem: Number,
    descricaoRetorno: String
  },
  methods: {
    alimentarObjeto() {
      this.refresh()
    },
    obterDecisao() {
      const th = this

      return th.$api.Functions.ObterDecisaoAnalise(
        th.situacaoBmpOrigem,
        th.onboarding,
        th.comparativoDados
      )
    },
    obterDetalhesDecisao() {
      const th = this
      const decisao = th.obterDecisao()

      if (th.descricaoRetorno)
        return th.descricaoRetorno

      if (decisao === 'Reprovado')
        return 'Reprovado por Políticas Internas. Esta informação é confidencial e não pode ser compartilhada.'

      if (decisao === 'Pendente de Mesa')
        return 'Em análise manual pelo time da BMP. Em breve o status será atualizado.'

      return ''
    },
    refresh() {
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped>
</style>
